import type { ReactNode } from 'react'
import { BasePopover } from './BasePopover'

interface ActionPopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  trigger: ReactNode
  children: ReactNode
  className?: string
  onMobileClick?: () => void
  isActive?: boolean
}

export function ActionPopover({
  open,
  onOpenChange,
  trigger,
  children,
  className,
  onMobileClick,
  isActive,
}: ActionPopoverProps) {
  return (
    <BasePopover
      open={open}
      onOpenChange={onOpenChange}
      trigger={trigger}
      className={className}
      onMobileClick={onMobileClick}
      isActive={isActive}
    >
      {children}
    </BasePopover>
  )
}
